import theme from '@services/theme'

export default {
    root: {
        width: '100%',
        marginTop: 10
    },
    icon: {
        fontSize: '32px',
        color: theme.palette.text.secondary
    },
    img: {
      width: '64px'
    },
    label: {
        color: theme.palette.text.secondary,
        fontWeight: 'normal'
    }
}